import type { IMarket } from "~/types/event";

import { getMarketGroupId } from "./buildMarketGroups";

const getSelectedOutcomeId = (
  markets: IMarket[],
  selections: string[]
): string | null => {
  const groupIds = new Set(
    markets
      .filter(({ id }) => selections.includes(id))
      .map((market) => getMarketGroupId(market))
  );

  return groupIds.size === 1 ? [...groupIds][0] : null;
};

export const isWithinOneOutcome = (
  markets: IMarket[],
  selections: string[]
): boolean => getSelectedOutcomeId(markets, selections) !== null;

export const isWholeGroupSelected = (
  markets: IMarket[],
  selections: string[]
): boolean => {
  const groupId = getSelectedOutcomeId(markets, selections);

  return (
    groupId !== null &&
    markets
      .filter((market) => getMarketGroupId(market) === groupId)
      .every(({ id }) => selections.includes(id))
  );
};
